/* RC accessibility toggles: switches + contrast fixer. Needs snippets/rc-a11y-head (window.RCA11y). */
(function () {
  var A = window.RCA11y; if (!A || A._ui) return; A._ui = true;

  function sync() {
    var s = { motion: A.reduceMotion(), contrast: A.contrast() };
    var bs = document.querySelectorAll('[data-rc-a11y-switch]');
    for (var i = 0; i < bs.length; i++) bs[i].setAttribute('aria-checked', s[bs[i].getAttribute('data-rc-a11y-switch')] ? 'true' : 'false');
  }
  A._sync = sync;
  /* The switch's own role/aria-checked is announced by screen readers; no live region (it would announce twice). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rc-a11y-switch]'); if (!b) return;
    A.set(b.getAttribute('data-rc-a11y-switch'), b.getAttribute('aria-checked') !== 'true');
    sync();                                                  // also when the state did not change (stale switch after a section reload)
  });
  document.addEventListener('rc:a11y-change', sync);
  document.addEventListener('shopify:section:load', sync);
  /* Splide carousels (assets/app.js keeps the instance on the Alpine component as .splide, config as .config):
     pause autoplay when Reduce motion turns on mid-visit; resume only sliders whose theme config autoplays. */
  var lastMotion = A.reduceMotion();
  function splides(on) {
    var els = document.querySelectorAll('.splide'), seen = [];
    for (var i = 0; i < els.length; i++) {
      try {
        var el = els[i], data = null, sp = null;
        try { data = window.Alpine && Alpine.$data ? Alpine.$data(el) : null; } catch (x) {}
        sp = (data && data.splide) || el.splide;
        if (!sp || seen.indexOf(sp) > -1) continue; seen.push(sp);
        var ap = sp.Components && sp.Components.Autoplay; if (!ap) continue;
        if (!el.dataset.rcAutoplay) el.dataset.rcAutoplay = (data && data.splide && data.config ? data.config.autoplay : sp.options && sp.options.autoplay) ? '1' : '0';
        if (on) ap.pause(); else if (el.dataset.rcAutoplay === '1') ap.play();
      } catch (x) {}
    }
  }
  document.addEventListener('rc:a11y-change', function (e) {
    if (e.detail.reduceMotion === lastMotion) return;
    lastMotion = e.detail.reduceMotion; splides(lastMotion);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  /* ---------- Contrast fixer: only failing pairs change, always to in-palette colours ---------- */
  var DEEP = { gold: ['#6e6328', '#575266', '#3a3645'], green: ['#2f7a0c', '#245f09'] };
  var FILL = { gold: '#6e6328', green: '#2f7a0c' };
  var BRAND = [[178, 163, 92, 'gold'], [206, 179, 124, 'gold'], [184, 137, 62, 'gold'], [69, 190, 0, 'green']];
  var CREAM = '#FAF7F0', INK = '#3a3645', SLATE = '#575266';
  var SKIP = '.rc-a11y,.productInfo__atc button,.sticky-add-to-cart button';   // switches; both Add to Cart buttons are styled by rc-a11y.css so their loading state survives
  var SIDES = ['border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color'];   // longhands: revert keeps per-side colours
  var PRESERVE = { '87,82,102': 1, '58,54,69': 1 };          // brand slate + ink are already the target
  var done = new WeakSet(), changed = [], scrimmed = [];
  /* Per scan, reads happen first and writes are queued, then applied in one pass (no layout thrash). */
  var writes, fills, ifFilled, media;

  /* rgb()/rgba() and color(srgb r g b / a) with 0-1 (or %) channels; any other colour space -> null (left alone). */
  function rgb(s) {
    var m, k = s && /^color\(\s*srgb\s+([^)]*)\)/.exec(s);
    if (k) {
      m = k[1].replace('/', ' ').trim().split(/\s+/).map(function (v) { return v === 'none' ? 0 : /%$/.test(v) ? parseFloat(v) / 100 : parseFloat(v); });
      return m.length < 3 || isNaN(m[0] + m[1] + m[2]) ? null : { r: m[0] * 255, g: m[1] * 255, b: m[2] * 255, a: m[3] === undefined || isNaN(m[3]) ? 1 : m[3] };
    }
    if (!s || !/^rgba?\(/.test(s)) return null;
    m = s.match(/[\d.]+/g); return m ? { r: +m[0], g: +m[1], b: +m[2], a: m[3] === undefined ? 1 : +m[3] } : null;
  }
  function hex(h) { return { r: parseInt(h.substr(1, 2), 16), g: parseInt(h.substr(3, 2), 16), b: parseInt(h.substr(5, 2), 16), a: 1 }; }
  function lum(c) { var a = [c.r, c.g, c.b].map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }); return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2]; }
  function ratio(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
  function key(c) { return Math.round(c.r) + ',' + Math.round(c.g) + ',' + Math.round(c.b); }
  /* Brand family of a colour: nearest brand colour within RGB distance 40 (catches off-palette golds like #c89748). */
  function family(c) {
    for (var i = 0; i < BRAND.length; i++) { var b = BRAND[i], dr = c.r - b[0], dg = c.g - b[1], db = c.b - b[2]; if (dr * dr + dg * dg + db * db <= 1600) return b[3]; }
    return null;
  }
  /* Semi-transparent text renders as a blend with what is behind it: judge that, not the opaque colour. */
  function over(fg, bg) { var a = fg.a; return a >= 1 ? fg : { r: a * fg.r + (1 - a) * bg.r, g: a * fg.g + (1 - a) * bg.g, b: a * fg.b + (1 - a) * bg.b, a: 1 }; }
  function neutral(c) { return Math.max(c.r, c.g, c.b) - Math.min(c.r, c.g, c.b) < 24; }
  function hasText(el) { for (var c = el.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && c.nodeValue.trim()) return true; return false; }
  function large(cs) { var s = parseFloat(cs.fontSize), w = parseInt(cs.fontWeight, 10) || 400; return s >= 24 || (s >= 18.66 && w >= 700); }
  function pick(list, bg, need) { for (var i = 0; i < list.length; i++) if (ratio(hex(list[i]), bg) >= need) return list[i]; return null; }
  function setStyle(el, prop, val) { writes.push([el, prop, val]); }
  function scrim(el) { writes.push([el, null]); }
  /* A CSS background photo: a url() image on a box at least 3x the text's area, not sized as a small icon. */
  function photo(n, cs, r) {
    if (!/url\(/.test(cs.backgroundImage)) return false;
    var z = cs.backgroundSize, px = z.match(/[\d.]+px/g), b = n.getBoundingClientRect();
    if (px && !/%|cover|contain|auto/.test(z) && px.every(function (v) { return parseFloat(v) < 100; })) return false;
    return b.width * b.height >= 3 * r.width * r.height;
  }
  /* Nearest opaque background: {c, el}; {img: el} for a CSS background photo; null for any other image/gradient. */
  function backdrop(el, r) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return photo(n, cs, r) ? { img: n } : null;
      var c = rgb(cs.backgroundColor); if (c && c.a >= 0.95) return { c: c, el: n };
    }
    return { c: { r: 255, g: 255, b: 255, a: 1 }, el: null };
  }
  /* Media rects are read once per scan (lazily, only if a candidate needs them), so this stays linear on big pages.
     Search scope: 6 ancestors up; or, given the opaque dark section the text sits on (`within`), that whole section,
     however deep the text is (collection-hero breadcrumb, hero Trustpilot wordmark). Never the whole page. */
  function overMedia(el, within) {
    if (!media) {
      media = []; var all = document.querySelectorAll('img,video,picture,iframe');
      for (var k = 0; k < all.length; k++) { var b = all[k].getBoundingClientRect(); if (b.width && b.height) media.push([all[k], b]); }
    }
    var r = el.getBoundingClientRect(), top = el.parentElement;
    if (within && within !== document.body && within !== document.documentElement) top = within;
    else for (var i = 1; top && i < 6 && top.parentElement && top.parentElement !== document.documentElement; i++) top = top.parentElement;
    if (!top) return false;
    for (var j = 0; j < media.length; j++) {
      var m = media[j][0], q = media[j][1];
      if (q.width * q.height > r.width * r.height && q.left < r.right && q.right > r.left && q.top < r.bottom && q.bottom > r.top &&
          top.contains(m) && !m.contains(el) && !el.contains(m) && (!within || within.contains(m))) return true;
    }
    return false;
  }
  function fix(el) {
    if (done.has(el) || !hasText(el)) return;
    var rect = el.getBoundingClientRect(); if (!rect.width || !rect.height) return;   // hidden now: retried on next scan
    done.add(el);
    if (el.closest(SKIP)) return;
    var cs = getComputedStyle(el), fg = rgb(cs.color); if (!fg || fg.a < 0.5) return;
    var need = large(cs) ? 3 : 4.5, bd = backdrop(el, rect), fam = family(fg);
    if (!bd) { if (overMedia(el)) scrim(el); return; }
    if (bd.img) { if (fam || lum(fg) > 0.18) scrim(el); return; }   // CSS photo: light or brand text cannot be judged, scrim it
    var bg = bd.c; fg = over(fg, bg);
    var cr = ratio(fg, bg), bfam = family(bg);
    if (bfam && bd.el) {                                   // text on a gold/green fill (buttons, badges)
      if (cr < need) {
        if (!fills.has(bd.el)) { fills.add(bd.el); setStyle(bd.el, 'background-color', FILL[bfam]); for (var s = 0; s < SIDES.length; s++) setStyle(bd.el, SIDES[s], FILL[bfam]); }
        setStyle(el, 'color', CREAM);
      } else if (ratio(fg, hex(FILL[bfam])) < need) ifFilled.push([el, bd.el]);   // passes now, would fail once the fill deepens
      return;
    }
    if (lum(fg) > 0.6 && lum(bg) > 0.6) { if (overMedia(el)) scrim(el); return; }   // light text "on light" = over a photo
    if (lum(bg) < 0.2) {                                   // dark surfaces (footer, dark bands) already pass...
      if ((fam || lum(fg) > 0.3) && overMedia(el, bd.el)) scrim(el);   // ...unless a photo inside that surface covers it (dark hero fallback)
      return;
    }
    if (PRESERVE[key(fg)]) return;
    if (fam) {
      if (cr < need) { if (overMedia(el)) { scrim(el); return; } var c = pick(DEEP[fam], bg, need); if (c) setStyle(el, 'color', c); }
      return;
    }
    if (neutral(fg) && cr < 7) {                           // Rolex layer: weak greys -> ink, secondary greys -> slate where it reaches 7:1
      // 6.99, not 7: slate on cream measures 6.9997. 7:1 is our own Rolex-style bar, not WCAG (AA is 4.5), so cream counts.
      var to = cr >= 4.5 && ratio(hex(SLATE), bg) >= 6.99 ? SLATE : INK;
      if (ratio(hex(to), bg) > cr) setStyle(el, 'color', to); return;
    }
    if (cr < need) { var c2 = pick([INK], bg, need); if (c2) setStyle(el, 'color', c2); }
  }
  /* Neighbouring scrim candidates under one parent (that holds no media itself and is mostly their text) get one
     scrim on the parent instead of overlapping boxes; the texts inside turn cream. Reads only: runs before any write. */
  function group() {
    var ps = [], ks = [], i, j;
    for (i = 0; i < writes.length; i++) if (writes[i][1] === null) {
      var p = writes[i][0].parentElement; if (!p || p === document.body) continue;
      j = ps.indexOf(p); if (j < 0) { ps.push(p); ks.push([]); j = ps.length - 1; }
      ks[j].push(writes[i]);
    }
    for (i = 0; i < ps.length; i++) {
      if (ks[i].length < 2 || ps[i].querySelector('img,video,picture,iframe')) continue;
      var u = null, pr = ps[i].getBoundingClientRect();
      for (j = 0; j < ks[i].length; j++) {
        var q = ks[i][j][0].getBoundingClientRect();
        u = u ? { l: Math.min(u.l, q.left), t: Math.min(u.t, q.top), r: Math.max(u.r, q.right), b: Math.max(u.b, q.bottom) } : { l: q.left, t: q.top, r: q.right, b: q.bottom };
      }
      if ((u.r - u.l) * (u.b - u.t) * 3 < pr.width * pr.height) continue;
      for (j = 0; j < ks[i].length; j++) ks[i][j][1] = 'in';
      writes.push([ps[i], null]);
    }
  }
  /* Neighbouring scrims that cannot share a parent scrim (the parent also holds a photo, e.g. the ISL feature banner)
     are joined into one panel instead: each gets square corners and a clip-path that grows its ring to the run's
     common left/right edge and 0.5px past a shared line halfway across each gap. Joined panels are opaque slate, so
     the 1px overlap cannot show as a darker line and WebKit's anti-aliased clip edge cannot show as a light seam.
     Recomputed every scan (widths change gaps); reads only, returns [el, insets] pairs. */
  var JV = ['--rc-jt', '--rc-jr', '--rc-jb', '--rc-jl', '--rc-js'], joined = [];
  function join() {
    var c = [], set = new Set(), i, out = [], rs = new Map();
    function add(e) { if (e && e.isConnected && !set.has(e)) { set.add(e); c.push(e); } }
    for (i = 0; i < scrimmed.length; i++) if (scrimmed[i][1] === 'rc-c-scrim') add(scrimmed[i][0]);
    for (i = 0; i < writes.length; i++) if (writes[i][1] === null) add(writes[i][0]);
    function inner(e) { for (var n = e.parentElement; n && n !== document.body; n = n.parentElement) if (set.has(n) || n.classList.contains('rc-c-scrim')) return true; return false; }
    c = c.filter(function (e) { return !inner(e); }); set = new Set(c);
    function box(e) { var r = rs.get(e); if (!r) { r = e.getBoundingClientRect(); r = { t: r.top, b: r.bottom, l: r.left, r: r.right, ring: parseFloat(getComputedStyle(e).fontSize) * 0.3 }; rs.set(e, r); } return r; }
    function next(e) {
      var n = e.nextElementSibling; if (!n || !set.has(n)) return null;
      var a = box(e), b = box(n);
      if (!(a.r - a.l) || !(b.r - b.l) || a.l >= b.r || b.l >= a.r || b.t < a.t || b.t - a.b > a.ring + b.ring + 4) return null;
      return n;
    }
    for (i = 0; i < c.length; i++) {
      var p = c[i].previousElementSibling; if (p && set.has(p) && next(p) === c[i]) continue;   // not the start of a run
      var run = [c[i]], n; while ((n = next(run[run.length - 1]))) run.push(n);
      if (run.length < 2) continue;
      var X = 0, L = Infinity, R = -Infinity, j, cut = [];
      for (j = 0; j < run.length; j++) { var q = box(run[j]); X = Math.max(X, q.ring); L = Math.min(L, q.l); R = Math.max(R, q.r); }
      for (j = 0; j < run.length - 1; j++) cut.push(Math.round((box(run[j]).b + box(run[j + 1]).t) / 2));
      for (j = 0; j < run.length; j++) {
        var k = box(run[j]), v = [j ? k.t - cut[j - 1] + 0.5 : X, R + X - k.r, j < run.length - 1 ? cut[j] - k.b + 0.5 : X, k.l - (L - X)];
        v = v.map(function (x) { return Math.max(0, Math.round(x * 1000) / 1000); });
        v.push(Math.ceil(Math.max.apply(null, v)) + 1);
        out.push([run[j], v]);
      }
    }
    return out;
  }
  function unjoin(el) { el.classList.remove('rc-c-scrim-join'); for (var i = 0; i < JV.length; i++) el.style.removeProperty(JV[i]); }
  function mark(el, c) { if (!el.classList.contains(c)) { el.classList.add(c); scrimmed.push([el, c]); } }
  function apply() {
    group();
    var js = []; try { js = join(); } catch (e) {}           // a join failure must not stop the scrims themselves
    applying = true;
    for (var k = 0; k < ifFilled.length; k++) if (fills.has(ifFilled[k][1])) setStyle(ifFilled[k][0], 'color', CREAM);
    for (var i = 0; i < writes.length; i++) {
      try {                                                  // one bad element must not stop the rest
        var w = writes[i], el = w[0];
        if (w[1] === 'in') { mark(el, 'rc-c-scrim-in'); continue; }
        if (w[1] === null) { mark(el, el.parentElement && el.parentElement.closest('.rc-c-scrim') ? 'rc-c-scrim-in' : 'rc-c-scrim'); continue; }
        var rec = [el, w[1], el.style.getPropertyValue(w[1]), el.style.getPropertyPriority(w[1])];
        el.style.setProperty(w[1], w[2], 'important'); changed.push(rec);
      } catch (e) {}
    }
    var now = js.map(function (x) { return x[0]; });
    for (i = 0; i < joined.length; i++) if (now.indexOf(joined[i]) < 0) { try { unjoin(joined[i]); } catch (e) {} }
    for (i = 0; i < js.length; i++) {
      try { var je = js[i][0]; for (var m = 0; m < JV.length; m++) je.style.setProperty(JV[m], js[i][1][m] + 'px'); je.classList.add('rc-c-scrim-join'); } catch (e) {}
    }
    joined = now;
    drop();
  }
  function scanAll() {
    if (!A.contrast()) return;
    A._scanCount = (A._scanCount || 0) + 1;
    writes = []; fills = new Set(); ifFilled = []; media = null;
    var els = document.body ? document.body.getElementsByTagName('*') : [];
    for (var i = 0; i < els.length; i++) { try { fix(els[i]); } catch (e) {} }
    apply();
    document.documentElement.dataset.rcContrastDone = '1';
  }
  function revert() {
    for (var i = changed.length - 1; i >= 0; i--) { try { var c = changed[i]; c[0].style.setProperty(c[1], c[2], c[3]); } catch (e) {} }
    for (var j = 0; j < scrimmed.length; j++) { try { scrimmed[j][0].classList.remove(scrimmed[j][1]); } catch (e) {} }
    for (var k = 0; k < joined.length; k++) { try { unjoin(joined[k]); } catch (e) {} }
    changed = []; scrimmed = []; joined = []; done = new WeakSet(); drop();
    delete document.documentElement.dataset.rcContrastDone;
  }
  /* Rescans (all through one 1s throttle): new elements, revealed content (class/style/hidden/open/aria-expanded),
     clicks, focus and finished transitions, and width changes. Text-only changes (ticking countdowns) are ignored,
     and records caused by the fixer's own writes are dropped. */
  var queued = 0, mo = null, applying = false;
  function queue() { if (queued || !A.contrast()) return; queued = setTimeout(function () { queued = 0; scanAll(); }, 1000); }
  function drop() { if (mo) mo.takeRecords(); applying = false; }
  function relevant(ms) {
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i];
      if (m.type === 'attributes') { if (!(m.target.closest && m.target.closest('.rc-a11y'))) return true; continue; }
      for (var j = 0; j < m.addedNodes.length; j++) if (m.addedNodes[j].nodeType === 1) return true;
    }
    return false;
  }
  A._fixContrast = scanAll;
  document.addEventListener('rc:a11y-change', function (e) { if (e.detail.contrast) scanAll(); else revert(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanAll); else scanAll();
  window.addEventListener('load', queue);
  ['click', 'focusin', 'transitionend'].forEach(function (t) { document.addEventListener(t, queue, true); });
  var lastW = window.innerWidth, rz = 0;
  window.addEventListener('resize', function () {
    clearTimeout(rz);
    rz = setTimeout(function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; queue(); } }, 200);
  });
  try {
    mo = new MutationObserver(function (ms) { if (!applying && relevant(ms)) queue(); });
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-expanded'] });
  } catch (e) {}
})();
